import connectWebViewJavascriptBridge from './utils';

function proxyCallApp(funName, arg) {
    return new Promise((resolve, reject) => {
        connectWebViewJavascriptBridge.call(this, bridge => {
            bridge.callHandler(funName, arg, rsp => {
                try {
                    rsp = JSON.parse(rsp);
                    // if (rsp.returnCode === 0) {
                    resolve(rsp);
                    // }
                    // else {
                    //     reject(rsp);
                    // }
                }
                catch (error) {
                    console.error(error);
                    reject(rsp);
                }
            });
        });
    });
}
export default proxyCallApp;
